import { Icon } from '@joor/design-system'

import { EmptyPayOrdersOverlayTestIds } from '../EmptyPayOrdersOverlay'
import { Body, Container, Header } from './Common.ui'

export const Empty90DaysOrdersTestIds = {
  BodyText: 'empty-90-days-orders-body-text',
} as const

export function Empty90DaysOrders() {
  return (
    <Container>
      <Icon
        data-testid={EmptyPayOrdersOverlayTestIds.OverlayIconOrder}
        iconName="order"
        iconSize="extraLarge"
        plain
      />
      <Header>{CONTENT_90_DAYS.HEADER_TEXT}</Header>
      <Body data-testid={Empty90DaysOrdersTestIds.BodyText}>
        {CONTENT_90_DAYS.BODY_TEXT_1}
      </Body>
    </Container>
  )
}

export const CONTENT_90_DAYS = {
  HEADER_TEXT: 'No JOOR Pay Orders',
  BODY_TEXT_1: `You do not have any payment on any order created in the last 3 months.
     Please click on 'Load all orders' to view all your JOOR Pay orders.`,
}
